export default __webpack_public_path__ + "static/media/cat-4.8b03931e.svg";